module.exports = __webpack_public_path__ + "media/gong1.7f4e7da0.wav";